import { create } from "zustand"

export const getOrderClass = (order?: number): string => {
  switch (order) {
    case 1:
      return "order-1"
    case 2:
      return "order-2"
    case 3:
      return "order-3"
    case 4:
      return "order-4"
    case 5:
      return "order-5"
    default:
      return "order-6"
  }
}

type PageLayoutState = {
  stickyFooterHeight: number
  calculateStickyFooterHeight: (height: number) => void
  resetStickyFooterHeight: () => void
}

export const usePageLayoutState = create<PageLayoutState>()((set) => ({
  stickyFooterHeight: 0,
  calculateStickyFooterHeight: (height: number) =>
    set((state) => {
      const newHeight = Math.max(state.stickyFooterHeight + height, 0)
      document.body.style.setProperty(
        "--sticky-footer-height",
        `${newHeight}px`
      )
      return { stickyFooterHeight: newHeight }
    }),
  resetStickyFooterHeight: () => {
    document.body.style.setProperty("--sticky-footer-height", "0px")
    return { stickyFooterHeight: 0 }
  },
}))
